import {
  KEYWORD_MESSAGE_ROBOT_INDEX,
  SEND_MESSAGE_ROBOT_INDEX,
  SET_TAG_ROBOT_INDEX,
  TASK_CREATING_ROBOT_INDEX,
  TRANSITION_FROM_THE_SALES_FUNNEL_ROBOT_INDEX,
  TRANSITION_FROM_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX,
  TRANSITION_TO_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX,
} from '@app/components/Modals/BotDetailsModal/constants/botIndexes';

export const botFieldsConfig: Record<
  string,
  Record<
    string,
    {
      fields: Array<string>;
    }
  >
> = {
  [TRANSITION_TO_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX]: {
    // Временно убираем
    // ByTimer: {
    //   fields: ['trigger', 'deadline', 'funnelStage', 'comment'],
    // },
    ChangeRecordStatus: {
      fields: [
        'trigger',
        'deadline',
        'status',
        'services',
        'serviceCategories',
        'internalMovement',
        'comment',
      ],
    },
    TagIsSet: {
      fields: ['trigger', 'deadline', 'tags', 'comment'],
    },
    AiClientSearch: {
      fields: [
        'trigger',
        'searchPrompt',
        'scanPeriod',
        'internalMovement',
        'comment',
      ],
    },
  },
  [TRANSITION_FROM_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX]: {
    ByTimer: {
      fields: ['trigger', 'deadline', 'funnelStage', 'comment'],
    },
    TagIsSet: {
      fields: ['trigger', 'deadline', 'funnelStage', 'tags', 'comment'],
    },
  },
  [TRANSITION_FROM_THE_SALES_FUNNEL_ROBOT_INDEX]: {
    ByTimer: {
      fields: ['trigger', 'deadline', 'funnel', 'funnelStage', 'comment'],
    },
    TagIsSet: {
      fields: [
        'trigger',
        'deadline',
        'funnel',
        'funnelStage',
        'tags',
        'comment',
      ],
    },
  },
  [TASK_CREATING_ROBOT_INDEX]: {
    ByTimer: {
      fields: ['trigger', 'deadline', 'comment'],
    },
  },
  [SET_TAG_ROBOT_INDEX]: {
    ByTimer: {
      fields: ['trigger', 'deadline', 'ignoreSchedule', 'comment'],
    },
    TagIsSet: {
      fields: ['trigger', 'deadline', 'tags', 'ignoreSchedule', 'comment'],
    },
    // Событийный триггер: срок и расписание бэкенд не использует
    IncomingMessage: {
      fields: ['trigger', 'incomingMessage', 'comment'],
    },
  },
  [KEYWORD_MESSAGE_ROBOT_INDEX]: {
    IncomingMessage: {
      fields: ['comment'],
    },
  },
  [SEND_MESSAGE_ROBOT_INDEX]: {
    DateRecord: {
      fields: [
        'trigger',
        'deadline',
        'status',
        'services',
        'employees',
        'comment',
      ],
    },
    ChangeRecordStatus: {
      fields: [
        'trigger',
        'deadline',
        'status',
        'services',
        'employees',
        'comment',
      ],
    },
    TagIsSet: {
      fields: ['trigger', 'deadline', 'tags', 'comment'],
    },
    ChannelIsEstablished: {
      fields: ['trigger', 'deadline', 'comment', 'socialType'],
    },
    ByTimer: {
      fields: ['trigger', 'deadline', 'comment'],
    },
  },
};
